import React from 'react';
import { PDFReaderBrowser } from '@/components/file-viewers/reactPdf';

interface PdfViewerWrapperProps {
  url: string;
  filename?: string;
  content_type?: string;
  preview_url?: string;
  containerStyles?: Record<string, any>;
  showControls?: boolean;
  showReplaceControl?: boolean;
  isFullscreen?: boolean;
  handleUpload?: (selectedFiles: File[]) => void;
  acceptedFiles?: string[];
  maxFiles?: number;
  styles?: Record<string, any>;
  updateFromResumeControl?: React.ReactNode;
}

export const PdfViewerWrapper = ({
  url,
  filename,
  content_type,
  preview_url,
  containerStyles = {},
  showControls = true,
  showReplaceControl = false,
  isFullscreen = false,
  handleUpload = () => {},
  acceptedFiles = [],
  maxFiles = 1,
  styles = {},
  updateFromResumeControl,
}: PdfViewerWrapperProps) => {
  return (
    <PDFReaderBrowser
      file={url}
      content_type={content_type}
      preview_url={preview_url}
      fileName={filename}
      containerStyles={containerStyles}
      showControls={showControls}
      showReplaceControl={showReplaceControl}
      isFullscreen={isFullscreen}
      handleUpload={handleUpload}
      acceptedFiles={acceptedFiles}
      maxFiles={maxFiles}
      styles={styles}
      updateFromResumeControl={updateFromResumeControl}
    />
  );
};
